import React from "react";
import useIsMobile from "hooks/useIsMobile";
import { DashboardLayoutType, IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import DashboardComponent from "../../group-component/GroupComponent";

interface VerticalLayoutProps {
  components: IDashboardComponent[];
  align?: string;
  layoutType: DashboardLayoutType;
  groupId: string;
}

const VerticalLayout = ({ components, align, layoutType, groupId }: VerticalLayoutProps) => {
  const isMobile = useIsMobile();

  return (
    <div className={`flex flex-column align-items-${align?.toLowerCase()} w-full`}>
      {components?.length > 0 ? (
        components.map(component => (
          <div
            key={component.id}
            className={`w-${isMobile || component.type === "SEPARATOR" ? 12 : component.layout?.VERTICAL?.width ?? 6}`}
            style={{
              height:
                component.type === "NOT_SUPPORTED"
                  ? 200
                  : component.layout?.VERTICAL?.height || 550,
            }}
          >
            <DashboardComponent
              groupId={groupId}
              componentId={component.id}
              component={component}
              layoutType={layoutType}
            />
          </div>
        ))
      ) : (
        <div className="pl-3">Group has no components</div>
      )}
    </div>
  );
};

export default VerticalLayout;
